import { render } from "./InvoiceCreateRentalInvoice.vue?vue&type=template&id=740d5558&scoped=true"
import script from "./InvoiceCreateRentalInvoice.vue?vue&type=script&lang=js"
export * from "./InvoiceCreateRentalInvoice.vue?vue&type=script&lang=js"

import "./InvoiceCreateRentalInvoice.vue?vue&type=style&index=0&id=740d5558&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740d5558"]])

export default __exports__